import { HStack, Spacer, Text } from '@cardboard-ui/react';
import React, { PropsWithChildren } from 'react';
import { useDesktopMenu } from './DesktopMenuContext';
import { Layout, useActiveLayout } from 'utils/LayoutProvider';

export const MenuSubtitle = ({
  children,
  rightButton,
}: PropsWithChildren<{ rightButton?: React.ReactElement }>) => {
  const { isCollapsed } = useDesktopMenu();
  const activeLayout = useActiveLayout();
  if (isCollapsed && activeLayout === Layout.DESKTOP) {
    return null;
  }
  return (
    <HStack w="100%" h={6}>
      <Text as="strong" fontSize="xs">
        {children}
      </Text>
      <Spacer />
      {rightButton}
    </HStack>
  );
};
